// extracted by mini-css-extract-plugin
export default {"classForm":"classForm-d9Ik9","classFormBody":"classFormBody-bPb0h"};